import { render, staticRenderFns } from "./Parse.vue?vue&type=template&id=531ebd0f"
import script from "./Parse.vue?vue&type=script&lang=ts"
export * from "./Parse.vue?vue&type=script&lang=ts"
import style0 from "./Parse.vue?vue&type=style&index=0&id=531ebd0f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports